
export class Planeringsstatus {
// eslint-disable-next-line sonarjs/public-static-readonly
    static Tillgangligt = "Tillgängligt";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Fardigplanerat = "Färdigplanerat";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static UnderPlanering = "Under planering";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Utfort = "Utfört";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static Ajourhallet = "Ajourhållet";

    // eslint-disable-next-line sonarjs/public-static-readonly
    static TillgangligtEllerSenare = [
        Planeringsstatus.Tillgangligt,
        Planeringsstatus.Utfort,
        Planeringsstatus.Ajourhallet
    ];

    static IsTillangligEllerSenare(status: string) {
        return Planeringsstatus.TillgangligtEllerSenare.some(x => x === status);
    }
}
